export enum actionTypes {
  // ****** app data actions ******
  SET_APP_DATA__START = 'SET_APP_DATA__START',
  SET_APP_DATA__SUCCESS = 'SET_APP_DATA__SUCCESS',
  SET_APP_DATA__FAIL = 'SET_APP_DATA__FAIL',
  // ****** position actions ******
  SET_POSITION__START = 'SET_POSITION__START',
  SET_POSITION__SUCCESS = 'SET_POSITION__SUCCESS',
  SET_POSITION__FAIL = 'SET_POSITION__FAIL',
  // ****** tokens filter actions ******
  ADD_FILTER = 'ADD_FILTER',
  CLEAR_FILTERS = 'CLEAR_FILTERS',
  // ****** address data actions ******
  GET_ADDRESS_DATA__START = 'GET_ADDRESS_DATA__START',
  GET_ADDRESS_DATA__SUCCESS = 'GET_ADDRESS_DATA__SUCCESS',
  GET_ADDRESS_DATA__FAIL = 'GET_ADDRESS_DATA__FAIL',

  // ****** sourcify data actions ******
  GET_SOURCIFY_DATA__START = 'GET_SOURCIFY_DATA__START',
  GET_SOURCIFY_DATA__SUCCESS = 'GET_SOURCIFY_DATA__SUCCESS',
  GET_SOURCIFY_DATA__FAIL = 'GET_SOURCIFY_DATA__FAIL',
}
